import { atom } from "jotai"
import { GetRequest } from "../api"
import { urls } from "../constants"
import { alertAtom } from "./globalStateAtoms"


export const BranchBalanceReportData = atom([])
export const fetchBranchBalanceData = atom(null, async (get, set, data,key) => {
  try {
    const res = await GetRequest(urls.getBranchBalanceReport + '?', data)
    if (res.status === 'Success') {
      if (key === 'filterData') {
        if (res?.Data?.table?.length > 0) {
          set(BranchBalanceReportData, res.Data.table)
        } else {
          set(alertAtom, { show: true, msg: 'No Data Found For Selected Date Range', nextId: '' })
          set(BranchBalanceReportData, [])
        }
      }
    }
  } catch (error) {
    console.error('Error fetching Expense Heade:', error)
    set(BranchBalanceReportData, [])
  }
})
export const BookingLRTrackStatusData = atom([])
export const fetchLRStatusData = atom(null, async (get, set, data,key) => {
  try {
    const res = await GetRequest(urls.bookingTrackingStatus + '?', data)
    if (res.status === 'Success') {
      if (res?.Data?.Table?.length > 0) {
          set(BookingLRTrackStatusData, res.Data.Table)
        } else {
          set(alertAtom, { show: true, msg: 'No Data Found', nextId: '' })
          set(BookingLRTrackStatusData, [])
        }
    }
  } catch (error) {
    console.error('Error fetching Expense Heade:', error)
    set(BookingLRTrackStatusData, [])
  }
})
export const ChildCompanyListData = atom([])
export const fetchChildCompanyListData = atom(null, async (get, set, data,key) => {
  try {
    const res = await GetRequest(urls.getChildCompanyListAll + '?', data)
    // if (res.status === 'Success') {
      if (res?.Companies?.length > 0) {
          set(ChildCompanyListData, res?.Companies)
        } else {
          set(alertAtom, { show: true, msg: 'No Data Found', nextId: '' })
          set(ChildCompanyListData, [])
        }
    // }
  } catch (error) {
    console.error('Error fetching Child Company:', error)
    set(ChildCompanyListData, [])
  }
})